import { InputField } from './input-field';

export function InputIdCard({ name = 'id_number', label = 'เลขบัตรประจำตัวประชาชน', required = false, ...props }) {
  return (
    <InputField
      name={name}
      label={label}
      required={required}
      rules={[
        {
          validator: (_, value) => {
            if (!value) {
              return Promise.resolve();
            }

            if (!/^[0-9]{13}$/g.test(value)) {
              return Promise.reject(new Error('ต้องมีทั้งหมด 13 ตัว'));
            }
            let i;
            let sum = 0;
            for (i = 0, sum = 0; i < 12; i++) {
              sum += Number.parseInt(value.charAt(i)) * (13 - i);
            }
            const checkSum = (11 - (sum % 11)) % 10;
            if (checkSum === Number.parseInt(value.charAt(12))) {
              return Promise.resolve();
            }
            return Promise.reject(new Error('เลขบัตรประชาชนไม่ถูกต้อง'));
          },
        },
      ]}
      {...props}
    />
  );
}
